import { formatDuration, intervalToDuration } from "date-fns";

export const drivingDetails = (distanceFormatted, durationSeconds) => {
  const formattedDriveTime = formatDuration(
    intervalToDuration({ start: 0, end: durationSeconds * 1000 }),
    { format: ["hours", "minutes"] },
  );

  return `${distanceFormatted} / Drive in ${formattedDriveTime}`;
};

export const formatAddress = (address) => {
  let addr = "";
  if (address.streetLineOne) {
    addr += address.streetLineOne + ", ";
  }
  if (address.streetLineTwo) {
    addr += address.streetLineTwo + ", ";
  }
  if (address.city) {
    addr += address.city + ", ";
  }
  if (address.state) {
    addr += address.state + " ";
  }
  if (address.zip) {
    addr += address.zip;
  }
  return addr;
};
